import { getPositionInfo } from '@js/core/positionTypes.js';

export default function defaultSearchFilters() {
    return {
        connection: {
            private: false,
            connected: false,
            disconnected: false,
        },
        position_type: {
            tense: 'any',
            value: 'any',
        },
        salary: {
            tense: 'future',
            probono: 'any',
            equity: 'any',
            range: [0, getPositionInfo('max', 'permanent')],
            unspecified: true,
            positionType: 'permanent',
        },
        location: {
            tense: 'current',
            boxes: [],
        },
        industry: {
            tense: 'current',
            boxes: [],
        },
        career: {
            tense: 'current',
            boxes: [],
        },
        classification: {
            tense: 'current',
            boxes: [],
        },
        company_id: {
            tense: 'current',
            tenseOptions: ['current', 'any'],
            boxes: [],
        },
        company_type: {
            tense: 'current',
            boxes: [],
        },
        project: {
            boxes: [],
        },
        tag_candidate: {
            boxes: [],
        },
        tag_person: {
            boxes: [],
        },
        tag_task: {
            boxes: [],
        },
        team: {
            range: [1, 5],
            unspecified: true,
        },
        status: {
            range: [0, 4],
        },
        recent: {
            months: null,
        },
    };
}